module.exports = __webpack_public_path__ + "static/media/sric.361b42d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Master/sric.svg
// module id = 156
// module chunks = 0